<template>
    <div class="filter-group mt-2"
         v-bind:class="{'is-open': filter.isOpen, 'has-title': !!filter.title, 'no-title': !filter.title}">

        <div class="filter-group-item filter-item" v-if="filter.title" @click="clickFilter(filter)">
            {{filter.title}}
            <span class="filter-group-icon float-right">
                {{filter.isOpen ? '-' : '+'}}
            </span>
        </div>

        <div v-if="!filter.title || filter.isOpen" class="filter-group filter-options"
             v-for="option in filter.options">

            <div class="filter-group-item filter-option" @click="clickOption(option)">
                {{option.title}}
                <span class="filter-group-icon float-right">
                    {{option.isOpen ? '-' : '+'}}
                </span>
            </div>

            <div v-if="option.isOpen" class="filter-group calendar-group">

                <timetable-list-filter
                        v-for="subFilter in option.sub_filters"
                        :key="subFilter.key"
                        :filter="subFilter"
                        :calendars="calendars"
                        :selected-calendar="selectedCalendar"
                        @select-calendar="selectCalendar($event, filter, option)"></timetable-list-filter>

                <div class="calendars" v-if="option.show_calendars">
                    <div class="filter-group-item calendar-item"
                         v-for="calendar in option.calendars"
                         @click="selectCalendar(calendar, filter, option)"
                         v-bind:class="{'active' : isCalendarActive(calendar)}">
                        <span class="calendar-title">
                            <i v-bind:class="calendar.icon || 'icon-user'"></i>
                            {{calendar.title}}</span>

                        <div class="calendar-info">
                            <img v-bind:src="calendar.picture" alt="" v-img-zoom>
                            <p v-for="info in calendar.info">
                                <small>{{info.key}}<br><b v-html="info.value"></b></small>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            filter: {
                required: true
            },
            calendars: {
                default: () => []
            },
            selectedCalendar: {
                default: () => {
                }
            },
            texts: {
                default: () => {
                }
            },
        },

        mounted() {
            this.filter.options.forEach((option) => {
                if (option.show_calendars) {
                    option.calendars = this.calendars.filter((calendar) => calendar.filters[this.filter.key] == option.value)
                }
            });
        },

        methods: {
            selectCalendar(calendar, filter, option) {
                filter.isOpen = true;
                option.isOpen = true;
                calendar.isOpen = !calendar.isOpen;
                this.$emit('select-calendar', calendar);
                // this.$forceUpdate();
            },

            clickFilter(filter) {
                filter.isOpen = !filter.isOpen;
                this.$forceUpdate();
            },

            clickOption(option) {
                option.isOpen = !option.isOpen;
                this.$forceUpdate();
            },

            isCalendarActive(calendar) {
                return this.selectedCalendar && this.selectedCalendar.id == calendar.id;
            }
        },

        watch: {
            selectedCalendar() {
                for (let i = 0; i < this.filter.options.length; i++) {
                    const option = this.filter.options[i];

                    if (option.show_calendars) {
                        for (let j = 0; j < option.calendars.length; j++) {
                            const calendar = option.calendars[j];

                            if (this.selectedCalendar?.id === calendar.id) {
                                this.filter.isOpen = true;
                                option.isOpen = true;
                                this.$forceUpdate();
                                return;
                            }
                        }
                    }
                }
            }
        }
    }
</script>
<style>

</style>
